(() => {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  const SELECTOR = [
    '.cover-image',
    '.cover-video',
    '.iwc-image',
    '.iwts-background-image',
    '.bc',
    '.pgb-background',
    '.gv-designer-banner__bg'
  ].join(', ');

  const CONFIG = {
    '.cover-image': {
      strength: 0.08,
      scale: 1.06
    },

    '.cover-video': {
      strength: 0.08,
      scale: 1.06
    },

    '.iwc-image': {
      strength: 0.10,
      scale: 1.08
    },

    '.iwts-background-image': {
      strength: 0.09,
      scale: 1.07
    },

    '.gv-designer-banner__bg': {
      strength: 0.08,
      scale: 1.05
    },

    '.bc': {
      strength: 0.08,
      scale: 1
    },

    '.pgb-background': {
      strength: 0.08,
      scale: 1.06
    }

  };

  const elements = new Set();
  let ticking = false;

  function getConfig(element) {
    return Object.entries(CONFIG)
      .find(([selector]) => element.matches(selector))?.[1];
  }

  function update() {
    ticking = false;

    const viewportHeight = window.innerHeight;
    const viewportCenter = viewportHeight / 2;

    elements.forEach((element) => {

      const rect = element.getBoundingClientRect();

      if (
        rect.bottom < -100 ||
        rect.top > viewportHeight + 100
      ) {
        return;
      }

      const config = getConfig(element);

      if (!config) return;

      const elementCenter =
        rect.top + rect.height / 2;

      const offset =
        elementCenter - viewportCenter;

      const y =
        offset * config.strength * -1;

      element.style.transform =
        `translate3d(0, ${y.toFixed(2)}px, 0) scale(${config.scale})`;
    });
  }

  function requestUpdate() {
    if (ticking) return;

    ticking = true;

    requestAnimationFrame(update);
  }

  const observer = new IntersectionObserver(
    (entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {
          elements.add(entry.target);
        } else {
          elements.delete(entry.target);
        }

      });

      requestUpdate();
    },
    {
      rootMargin: '100px 0px'
    }
  );

  function init() {

    document
      .querySelectorAll(SELECTOR)
      .forEach((element) => {

        element.style.willChange = 'transform';

        observer.observe(element);

      });

    requestUpdate();

    window.addEventListener(
      'scroll',
      requestUpdate,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      requestUpdate,
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

})();